import { ZapierIcon } from "assets/images";
import { Button } from "components";
import React from "react";

const Zapier = () => {
  return (
    <div
      className={`h-[236px] bg-[#F1F1F1] shadow-md flex flex-col justify-center px-6`}
    >
      <div className="flex flex-col gap-7">
        <div className="flex items-center space-x-2">
          <ZapierIcon className="w-10 h-10" />
          <p className="">Zapier</p>
        </div>
        <div className="flex flex-col gap-6">
          <p className="font-bold text-[#0D121D]">
            What is Zapier? Connect your apps and automate workflows. Easy
            automation for busy people.
            <br />
            Zapier moves info between your web apps automatically, so you can
            focus on your most important work.
          </p>

          <div className="w-[400px]">
            <Button>Connect Zapier Account</Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Zapier;
